export const formsGlobal = {
  password: {
    minLength: 6,
    maxLength: 15,
  },
};
